<template>
    <div class="pack-box gift-choice gift-choice__tableau "  >
    <div class="pack-title">
        <img src="/images/fr_new_home/cadeau.svg" alt="cadeaux" />
        <h3> Choisissez votre <span class="orange-text">cadeau</span></h3>
    </div>
    <h6 class="text-uppercase orange-text">Accédez à un catalogue complet de cadeaux</h6>
    <p>
        Le consommateur devrait toujours avoir le choix. C’est pourquoi, Test
        Achats vous propose de choisir parmi un catalogue de cadeaux variés&nbsp;:
    </p>
    <div class="tableau">
        <div class="tableau-title-container">
            <p class="tableau-title">Quelques  exemples  de cadeaux </p>
            <p class="product-price tableau-title">Prix</p>
        </div>
        <div class="product-row" v-for="elem in box_list">
            <p class="product-name" v-html="elem[0]"></p>
            <p class="product-price" v-html="elem[1]"></p>
        </div>
        <p class="asterix" v-if="meta.box_text" v-html="meta.box_text"></p>
    </div>
    </div>
</template>

<script>
import image_mixin from "../mixins/image_mixin";

export default {
    name: "GiftChoiceDynamic",
    mixins:[image_mixin],
}
</script>

<style scoped>

</style>
